import { render, staticRenderFns } from "./TemplateSlideDrawer.vue?vue&type=template&id=6a0c4ff9&lang=pug"
import script from "./TemplateSlideDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateSlideDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports